import ActionChainList from "@/routes/admin/ActionChainList";
import { AppointmentEditor } from "@/routes/admin/appointmentEditor";
import AuditLog from "@/routes/admin/auditLog";
import CompanyList from "@/routes/admin/companyList";
import AnchorDataOverview from "@/routes/admin/AnchorDataOverview";
import ExaminationList from "@/routes/admin/examinationList";
import FolderEditor from "@/routes/admin/folderEditor";
import GlobalSettingsList from "@/routes/admin/globalSettingsList";
import { FormEditor } from "@/routes/admin/formEditor";
import MailTemplateList from "@/routes/admin/mailTemplateList";
import TodoTemplateList from "@/routes/admin/todoTemplateList";
import MainCategoryList from "@/routes/admin/mainCategoryList";
import MeasurementDefinitionCreate from "@/routes/admin/measurementDefinitionCreate";
import MeasurementDefinitionList from "@/routes/admin/measurementDefinitionList";
import PermissionGroupList from "@/routes/admin/permissionGroupList";
import PermissionList from "@/routes/admin/permissionList";
import ProbeEditor from "@/routes/admin/probeEditor";
import ProbeList from "@/routes/admin/probeList";
import RuleList from "@/routes/admin/ruleList";
import TeamsList from "@/routes/admin/teamsList";
import { DocumentTemplateEditor } from "@/routes/admin/documentTemplateEditor";
import TodoList from "@/routes/admin/todoList";
import UserAdministration from "@/routes/userAdministration";
import ActionChainCreateAndEdit from "@/components/actionChain/actionChainCreateAndEdit";
import ActionChainProgress from "@/components/actionChain/actionChainProgress";
import ActionChainProvider from "@/components/actionChain/actionChainProvider";
import TranslationTable from "@/components/forms/translation/translationTable";
import MissingTranslationsTable from "@/components/forms/translation/missingTranslationsTable";
import MailTemplateEditor from "@/components/mailTemplate/mailTemplateEditor";
import TrackedServiceCustomCrud from "@/components/trackedService/trackedServiceCustomCrud";
import TrackedServiceExaminationTemplatesTable from "@/components/trackedService/trackedServiceExaminationTable";
import TrackedServiceMainTable from "@/components/trackedService/trackedServiceMainTable";
import TrackedServiceTemplatesTable from "@/components/trackedService/trackedServiceTemplates";
import TrackedServiceTypeTable from "@/components/trackedService/trackedServiceTypeTable";
import AnchorData from "@/routes/admin/anchorData";
import TasktrackingList from "@/routes/admin/tasktracking";
import AccessFailureLogList from "@/routes/admin/accessFailureLog";
import EmailBatchStatusList from "@/routes/admin/emailBatchStatusList";

const adminSubroutes = [
  {
    path: "/admin/userAdministration",
    name: "customer",
    icon: "employee",
    index: 29,
    permission: "frontend_view_user_administration",
  },
  {
    path: "/admin/companyList",
    name: "company",
    icon: "company",
    index: 30,
    permission: "frontend_view_company",
  },
  {
    path: "/admin/teams",
    name: "teams",
    icon: "teams",
    index: 39,
    permission: "frontend_view_team",
  },
  {
    path: "/admin/todoList",
    name: "todo_admin",
    icon: "todoCrudTable",
    index: 31,
    permission: "frontend_view_todo_table",
  },
  {
    path: "/admin/anchorData",
    name: "anchorData_navigation",
    icon: "anchorData",
    index: 44,
    permission: "frontend_view_anchordata",
  },
  {
    path: "/admin/anchorDataOverview",
    name: "anchordata_overview",
    icon: "anchorDataOverview",
    index: 43,
    permission: "frontend_view_anchordata",
  },
];
const settingsSoubRoutes = [
  {
    path: "/settings/globalSettings",
    name: "global_settings",
    icon: "settings",
    index: 47,
    permission: "frontend_view_setting",
  },
  {
    path: "/settings/mainCategoryList",
    name: "main_categories",
    icon: "mainCategory",
    index: 22,
    permission: "frontend_view_main_category",
  },
  {
    path: "/settings/examinationList",
    name: "examination",
    icon: "examinationList",
    index: 23,
    permission: "frontend_view_examination",
  },
  {
    path: "/settings/probeList",
    name: "probe",
    icon: "probe",
    index: 24,
    permission: "frontend_view_probe",
  },
  {
    path: "/settings/measurementDefinitionList",
    name: "measurementDefinitions",
    icon: "measurementDefinition",
    index: 25,
    permission: "frontend_view_measurement_definition",
  },
  {
    path: "/settings/documentTemplateEditor",
    name: "document_template_editor",
    icon: "documentTemplate",
    index: 27,
    permission: "frontend_view_document_template",
  },
  {
    path: "/settings/documentEditor",
    name: "folder",
    icon: "folder",
    index: 28,
    permission: "frontend_view_folder",
  },
  {
    path: "/settings/ruleList",
    name: "rules",
    icon: "rules",
    index: 33,
    permission: "frontend_view_rule",
  },
  {
    path: "/settings/mailTemplateList",
    name: "email_templates",
    icon: "template",
    index: 34,
    permission: "frontend_view_email_template",
  },
  {
    path: "/settings/todoTemplateList",
    name: "todo_templates",
    icon: "todoTemplates",
    index: 35,
    permission: "frontend_view_todo_template",
  },
  {
    path: "/settings/permissionList",
    name: "permissions",
    icon: "permissions",
    index: 37,
    permission: "frontend_view_permission",
  },
  {
    path: "/settings/permissionGroupList",
    name: "permissions_groups",
    icon: "permissionGroups",
    index: 38,
    permission: "frontend_view_permission_group",
  },
  {
    path: "/settings/auditlog",
    name: "audit_log",
    icon: "auditLog",
    index: 40,
    permission: "frontend_view_auditlog",
  },
  {
    path: "/settings/actionChains",
    name: "actionchains",
    icon: "actionChain",
    index: 41,
    permission: "frontend_view_action_chains",
  },
  {
    path: "/settings/translations",
    name: "translations",
    icon: "translation",
    index: 42,
    permission: "frontend_view_translationlist",
  },
  {
    path: "/settings/missingTranslations",
    name: "missing_translations",
    icon: "translation",
    index: 45,
    permission: "frontend_view_translationlist",
  },
  {
    path: "/settings/tasktracking",
    name: "tasktracking",
    icon: "tasktracking",
    index: 43,
    permission: "frontend_view_tasktrackinglist",
  },
  {
    path: "/settings/accessfailurelog",
    name: "access_failure_log",
    icon: "accessFailureLog",
    index: 46,
    permission: "frontend_view_accessfailurelog",
  },
  {
    path: "/settings/emailstatus",
    name: "email_batch_status",
    icon: "batchEmailStatus",
    index: 44,
    permission: "frontend_view_email_batch_status_list",
  },
];
const trackedServiceSubRoutes = [
  {
    path: "/trackedservice/recorded",
    name: "trackedservice_recorded",
    icon: "trackedService",
    index: 5000,
    permission: "frontend_view_tracked_service",
  },
  {
    path: "/trackedservice/types",
    name: "trackedservice_type",
    icon: "trackedServiceTypes",
    index: 5001,
    permission: "frontend_view_trackedservice_types",
  },
  {
    path: "/trackedservice/trackedServiceTemplates",
    name: "trackedservice_templates",
    icon: "trackedServiceTemplates",
    index: 5002,
    permission: "frontend_view_trackedservice_tracked_service_templates",
  },
  {
    path: "/trackedservice/examinationTemplates",
    name: "trackedservice_examinations_templates",
    icon: "trackedServiceExaminationTemplates",
    index: 5003,
    permission: "frontend_view_trackedservice_examination_templates",
  },
];
const trackedServiceSubRoutContent = [
  {
    path: "recorded",
    name: "Leistungsnachweise",
    icon: "trackedService",
    element: <TrackedServiceMainTable />,
  },
  {
    path: "types",
    name: "Betreuungsart",
    icon: "trackedServiceTypes",
    element: <TrackedServiceTypeTable />,
  },
  {
    path: "trackedServiceTemplates",
    name: "Leistungsvorlagen",
    icon: "trackedServiceTemplates",
    element: <TrackedServiceTemplatesTable />,
  },
  {
    path: "examinationTemplates",
    name: "Leistungsverknüpfung",
    icon: "trackedServiceExaminationTemplates",
    element: <TrackedServiceExaminationTemplatesTable />,
  },
  {
    path: "createTrackedService",
    element: <TrackedServiceCustomCrud />,
  },
  {
    path: "editTrackedService/:trackedServiceId?",
    element: <TrackedServiceCustomCrud />,
  },
];

const settingsSubrouteContent = [
  {
    path: "globalSettings",
    element: <GlobalSettingsList />,
  },
  {
    path: "mainCategoryList",
    name: "Hauptkategorien",
    element: <MainCategoryList />,
    icon: "",
  },
  {
    path: "examinationList",
    element: <ExaminationList />,
    name: "Terminart",
    icon: "",
  },
  {
    path: "probeList",
    element: <ProbeList />,
    name: "Einzeluntersuchung",
    icon: "",
  },
  {
    path: "measurementDefinitionList",
    element: <MeasurementDefinitionList />,
    name: "Messpunktdefinitionen",
    icon: "",
  },

  {
    path: "documentTemplateEditor",
    element: <DocumentTemplateEditor />,
    name: "Document Template",
    icon: "",
  },
  {
    path: "documentEditor",
    element: <FolderEditor />,
    name: "Ordner",
    icon: "",
  },
  {
    path: "ruleList",
    element: <RuleList />,
    name: "Regeln",
    icon: "",
  },
  {
    path: "mailTemplateList",
    element: <MailTemplateList />,
    name: "Email Templates",
    icon: "",
  },
  {
    path: "todoTemplateList",
    element: <TodoTemplateList />,
    name: "Todo Templates",
    icon: "",
  },
  {
    path: "permissionList",
    element: <PermissionList />,
    name: "Berechtigungen",
    icon: "",
  },
  {
    path: "permissionGroupList",
    element: <PermissionGroupList />,
    name: "Berechtigungen - Gruppen",
    icon: "",
  },
  {
    path: "auditlog",
    element: <AuditLog />,
    name: "Auditlog",
    icon: "",
  },
  {
    path: "actionChains",
    element: <ActionChainList />,
    name: "Actionchains",
    icon: "",
  },
  {
    path: "formEditor/:formId?",
    element: <FormEditor />,
  },
  {
    path: "probeEditor/:probeId?",
    element: <ProbeEditor />,
  },
  {
    path: "createMeasurementDefinition/:measurementDefinitionId?",
    element: <MeasurementDefinitionCreate />,
  },
  {
    path: "documentTemplateEditor/:templateid?",
    element: <DocumentTemplateEditor />,
  },
  {
    path: "appointmentEditor/:appointmentId?",
    element: <AppointmentEditor />,
  },
  {
    path: "mailTemplateEditor/:mailTemplateId?",
    element: <MailTemplateEditor />,
  },
  {
    path: "actionChains/progress/:actionChainId?",
    element: <ActionChainProgress />,
  },
  {
    path: "actionChains/:actionChainId?",
    element: (
      <ActionChainProvider>
        <ActionChainCreateAndEdit />
      </ActionChainProvider>
    ),
  },
  {
    path: "translations",
    element: <TranslationTable />,
  },
  {
    path: "missingTranslations",
    element: <MissingTranslationsTable />,
  },
  {
    path: "tasktracking",
    element: <TasktrackingList />,
  },
  {
    path: "accessfailurelog",
    element: <AccessFailureLogList />,
  },
  {
    path: "emailstatus",
    element: <EmailBatchStatusList />,
  },
  {
    path: "emailstatus/:batchId?",
    element: <EmailBatchStatusList />,
  },
];

const adminSubrouteContent = [
  {
    path: "userAdministration/:subjectId?",
    element: <UserAdministration />,
    name: "Mitarbeiter",
    icon: "",
  },
  {
    path: "companyList",
    element: <CompanyList />,
    name: "Firma",
    icon: "",
  },
  {
    path: "todoList/:subjectId?",
    element: <TodoList />,
    name: "Todo",
    icon: "",
  },
  {
    path: "anchorData",
    element: <AnchorData />,
    name: "Stammdaten",
    icon: "",
  },
  {
    path: "anchorDataOverview",
    element: <AnchorDataOverview />,
    name: "Stammdaten Übersicht",
    icon: "",
  },
  {
    path: "teams",
    element: <TeamsList />,
    name: "Teams",
    icon: "",
  },
];

export {
  adminSubroutes,
  adminSubrouteContent,
  settingsSoubRoutes,
  settingsSubrouteContent,
  trackedServiceSubRoutes,
  trackedServiceSubRoutContent,
};
